"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfigurations = getConfigurations;
const axios_1 = __importDefault(require("axios"));
const FALLBACK_ENDPOINT = "https://web-api.audi.com";
const removeTailingSlash = (url) => url.replace(/\/$/, "");
const defaultGetUrl = (baseUrl, country, language, audiCodes) => `${baseUrl}/casa/v1/${country.toLowerCase()}/${language.toLowerCase()}/getConfigurations?vehicleCodes=${audiCodes}`;
const PATH_MAPPING = [
    {
        schema: /^https:\/\/vue-agw\.assets\.audi\.com\/?/,
        getUrl: (baseUrl, country, language, audiCodes) => `${baseUrl}/rest/CarstoreService/v1/getConfigurations?country=${country}&language=${language}&vehicleCodes=${audiCodes}`,
    },
    {
        schema: /^https:\/\/.*web-api\.audi\.com\/?/,
        getUrl: defaultGetUrl,
    },
];
function getConfigurations(audiCodes, locale, configs) {
    return __awaiter(this, void 0, void 0, function* () {
        let casaAPI = FALLBACK_ENDPOINT;
        if (configs && configs.VUE_AGW_ENDPOINT) {
            casaAPI = configs.VUE_AGW_ENDPOINT;
        }
        const [language, country] = locale.split("-");
        const matches = PATH_MAPPING.filter((pm) => casaAPI.match(pm.schema));
        let getUrl;
        if (matches.length > 0) {
            getUrl = matches[0].getUrl;
        }
        else {
            getUrl = defaultGetUrl;
        }
        // https://carstore.audi.com/casa/v1/de/de/getConfigurations?vehicleCodes=ATSFHHB3
        const url = getUrl(removeTailingSlash(casaAPI), country, language, audiCodes);
        const a = yield axios_1.default.get(`${url}`, {
            headers: { "Content-Type": "application/json" },
        });
        return a.data[0];
    });
}
